"use client";

import React from "react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
export default function PrivateDriverHire() {
  return <section id="privatedriverhire" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        {/* Header Stack */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center max-w-3xl mx-auto">
          <div className="flex justify-center mb-3">
            <Badge variant="outline" className="bg-accent/40 text-accent-foreground border-accent px-3 py-1 text-xs tracking-wide uppercase font-semibold">
              Flexibler Stundenservice
            </Badge>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-accent-foreground tracking-tight mb-4">
            Privaten Fahrer in Hurghada mieten
          </h2>

          <p className="text-muted-foreground text-base md:text-lg leading-relaxed">
            Die Buchung eines Fahrzeugs mit Fahrer in Hurghada bietet Ihnen die volle Freiheit, Ihren Zeitplan flexibel zu gestalten. Wählen Sie Ihren Abholort, besuchen Sie Ziele entlang der Küste in Ihrem eigenen Tempo und reisen Sie mit einem persönlichen Fahrzeug und Chauffeur, der Ihnen während der gesamten gebuchten Zeit zur Verfügung steht.
          </p>
        </motion.div>
      </div>
    </section>;
}